import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function Customers() {

    const [customers, setCustomers] = useState<any[]>([]);

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await api.get('/customers');

                if (response.status !== 200) {
                    throw new Error('Network response was not ok');
                }
                console.log(response.data);
                setCustomers(response.data);
            } catch (error) {
                console.error('Error fetching customers:', error);
            }
        }

        fetchCustomers();
    }, []);

    const columns: ColumnDef<any>[] = [
        {
            accessorKey: 'name',
            header: 'Name'
        },
        {
            accessorKey: 'manager_email',
            header: 'Manager E-Mail'
        },
        {
            accessorKey: 'code',
            header: 'Code'
        },
        {
            accessorKey: 'max_uses',
            header: 'Lizenzen'
        },
        {
            accessorKey: 'uses',
            header: 'Lizenznutzung'
        },
        {
            accessorKey: 'expires_at',
            header: 'Ablaufdatum',
            cell: ({ row }) => {
                const rawDate = row.getValue('expires_at');
                const date = new Date(rawDate as any);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                const formatted = `${day}.${month}.${year}`;
                return <span>{formatted}</span>;
            }
        },
    ];

    if (!customers || customers.length === 0) {
        return (
            <div className="dashboard-customers">
                <p>Es wurden noch keine Kunden gefunden.</p>
            </div>
        );
    }

    return (
        <div className="dashboard-customers">
            <h4>Kunden ({customers.length})</h4>
            <DataTable
                columns={columns}
                data={customers}
            />
        </div>
    );
}